import {
  Lit3formBlock,
  html,
  unsafeHTML,
  classMap,
  icon,
} from '@Root/lib/lit-3form-block';
import { styles } from './css';
import {
  adobeCleanString,
  handleAdobeNavEvent,
  handleFileDownloadEvent,
  analyticsCtaDataObject,
} from '../../../helpers/adobe-analytics';

export class Daffney extends Lit3formBlock {
  static get characterName() {
    return 'daffney';
  }

  static get characterStyles() {
    return [...styles];
  }

  render() {
    return html`
      <div class="block-wrapper">
        <div class="block-grid daffney-layout">
          <div class="images">
            ${this.imagesArr.map(i => this.imageHTML(i[1]))}
          </div>
          ${this.horizontalRule}
        </div>
      </div>
    `;
  }

  imageHTML(image) {
    return !!image.url
      ? html`
          <a
            class="${classMap(this.imageWrapperClass(image))}"
            href=${this.imageHref(image)}
            @click="${event => this.handleDriverClick(image, event)}"
          >
            ${this.imageInternalHtml(image)}
          </a>
        `
      : html`
          <a
            class="${classMap(this.imageWrapperClass(image))}"
            href=${this.imageHref(image)}
            target="_blank"
            rel="noopener"
            @click="${event => this.handleDriverClick(image, event)}"
          >
            ${this.imageInternalHtml(image)}
          </a>
        `;
  }

  imageInternalHtml(image) {
    return !!image.text
      ? html`
          <div class="image">
            <img src=${this.imageUrl(image)} />
            <div class="image-driver">
              ${unsafeHTML(this.withLineBreaks(image.text))}
              ${icon('arrow', 'right-arrow')}
            </div>
          </div>
        `
      : html`
          <div class="image">
            <img src=${this.imageUrl(image)} />
          </div>
        `;
  }

  handleDriverClick(image, event) {
    const linkName = adobeCleanString(image.text || image.name || '');
    if (image.url) {
      handleAdobeNavEvent({
        navString: `NAV|Image Driver|${linkName}`,
        destinationUrl: image.url,
        event,
      });
    } else {
      // No destination url — the link opens the full-resolution image, which
      // is a file download, not a navigation.
      handleFileDownloadEvent(
        analyticsCtaDataObject({
          file_format: 'JPG',
          file_name: linkName,
          link_url: image.full_resolution_src,
          link_type: 'IMAGE',
          placement: 'Image Driver',
        })
      );
    }
  }

  imageHref(image) {
    return image.url ? image.url : image.full_resolution_src;
  }

  imageUrl(image) {
    return image.full_width
      ? this.imagebossUrl(image.src, null, 500)
      : this.imagebossUrl(image.src, 580, 500);
  }

  imageWrapperClass(image) {
    return {
      'image-wrapper': true,
      'image-wrapper-full': image.full_width,
    };
  }

  get ctaData() {
    return JSON.stringify(this.content.cta);
  }
}
Daffney.defineElement();
